module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-content fadeInRight animated tabBox",
    attrs: {
      "id": "PageRescureImportEdit"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "ibox-content",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "form-horizontal",
    staticStyle: {
      "padding": "30px 20px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label red",
    attrs: {
      "for": ""
    }
  }, [_vm._v("*保单号:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.dataInfo.policyNo.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataInfo.policyNo),
      expression: "dataInfo.policyNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxLength": "23",
      "disabled": _vm.mode == 'view'
    },
    domProps: {
      "value": (_vm.dataInfo.policyNo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataInfo, "policyNo", $event.target.value)
      }, function($event) {
        return _vm.$v.dataInfo.policyNo.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.dataInfo.policyNo.required && _vm.$v.dataInfo.policyNo.$error) ? _c('span', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("保单号为必填项")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label red"
  }, [_vm._v("*车牌号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.dataInfo.rescuedPlateNumber.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.dataInfo.rescuedPlateNumber),
      expression: "dataInfo.rescuedPlateNumber",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxLength": "20",
      "disabled": _vm.mode == 'view'
    },
    domProps: {
      "value": (_vm.dataInfo.rescuedPlateNumber)
    },
    on: {
      "keyup": _vm.setUpperCase,
      "blur": [_vm.isPlateNumberOk, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataInfo, "rescuedPlateNumber", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.dataInfo.rescuedPlateNumber.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.dataInfo.rescuedPlateNumber.required && _vm.$v.dataInfo.rescuedPlateNumber.$error) ? _c('span', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("该车牌号为必填项")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("车主姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataInfo.rescuedName),
      expression: "dataInfo.rescuedName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "disabled": _vm.mode == 'view'
    },
    domProps: {
      "value": (_vm.dataInfo.rescuedName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataInfo, "rescuedName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label red"
  }, [_vm._v("*手机号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.dataInfo.rescuedPhone.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.dataInfo.rescuedPhone),
      expression: "dataInfo.rescuedPhone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "disabled": _vm.mode == 'view'
    },
    domProps: {
      "value": (_vm.dataInfo.rescuedPhone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataInfo, "rescuedPhone", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.dataInfo.rescuedPhone.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.dataInfo.rescuedPhone.required && _vm.$v.dataInfo.rescuedPhone.$error) ? _c('span', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("手机号为必填项")]) : _vm._e(), _vm._v(" "), (!_vm.phoneSet) ? _c('span', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("请输入有效手机号")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label red"
  }, [_vm._v("*救援类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.dataInfo.rescueType.$error
    }
  }, [_vm._l((_vm.rescueTypeList), function(type, index) {
    return _c('div', {
      key: index,
      staticClass: "col-sm-3 control-label t_left"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dataInfo.rescueType),
        expression: "dataInfo.rescueType"
      }],
      attrs: {
        "type": "radio",
        "disabled": _vm.mode == 'view'
      },
      domProps: {
        "value": type.udccode,
        "checked": _vm._q(_vm.dataInfo.rescueType, type.udccode)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.dataInfo, "rescueType", type.udccode)
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(type.udcname))])])
  }), _vm._v(" "), (!_vm.$v.dataInfo.rescueType.required && _vm.$v.dataInfo.rescueType.$error) ? _c('span', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("救援类型为必填项")]) : _vm._e()], 2), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label red"
  }, [_vm._v("*请求时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.dataInfo.requestTime.$error
    }
  }, [(_vm.mode == 'add') ? _c('datepicker', {
    ref: "requestDate",
    staticClass: "form-control",
    attrs: {
      "time_24hr": true,
      "enableTime": true,
      "enableSeconds": true
    },
    on: {
      "change": function($event) {
        return _vm.$v.dataInfo.requestTime.$touch()
      }
    },
    model: {
      value: (_vm.dataInfo.requestTime),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "requestTime", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "dataInfo.requestTime"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$v.dataInfo.requestTime.required && _vm.$v.dataInfo.requestTime.$error) ? _c('span', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("请求时间为必填项")]) : _vm._e(), _vm._v(" "), (_vm.mode == 'view') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.dataInfo.requestTime),
      expression: "dataInfo.requestTime",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "11",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.dataInfo.requestTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataInfo, "requestTime", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label red"
  }, [_vm._v("*救援地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataInfo.rescuedAddress),
      expression: "dataInfo.rescuedAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "disabled": _vm.mode == 'view'
    },
    domProps: {
      "value": (_vm.dataInfo.rescuedAddress)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataInfo, "rescuedAddress", $event.target.value)
      }, function($event) {
        return _vm.$v.dataInfo.rescuedAddress.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.dataInfo.rescuedAddress.required && _vm.$v.dataInfo.rescuedAddress.$error) ? _c('span', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("救援地址为必填项")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "300px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [(_vm.mode == 'add') ? _c('button', {
    staticClass: "btn btn-primary white",
    attrs: {
      "disabled": !_vm.clickable
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保存")]) : _vm._e()])])]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModalMsg
    }
  }, [_vm._v("\n          " + _vm._s(_vm.messageStr) + "\n          "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModalMsg
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('tab-modal', {
    ref: "successModal",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.saveSuccess
    }
  }, [_vm._v("\n          保存成功！\n          "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveSuccess
    }
  }, [_vm._v("确定")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-607e5b0c","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/rescureimport/PageRescureImportEdit.vue
// module id = 1540
// module chunks = 0